import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Hero from "../components/Hero";

const StudentQuestionnairePage = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        studentNo: "",
        phone: "",
        phone2: "",
        school: "",
        duration: "",
        q1: "",
        q2: "",
        q3: "",
        q4: "",
        q5: "",
        q6: "",
        q7: "",
        q8: ""
    });

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    // Ensure the page scrolls to top whenever this page is navigated to or the id changes
    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && window?.scrollTo) {
                // instant jump to top to avoid flashing at previous scroll position
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            }
        } catch (e) {
            // fallback: simple assignment
            try {
                window.scrollTo(0, 0);
            } catch (err) {
                // ignore in environments without window
            }
        }
    }, []);

    const heroSlides = [
        {
            id: 1,
            image: "/assets/img/prog-1.jpg",
            title: "Student Questionnaire",
            subtitle: "Your feedback helps us strengthen the quality of teaching-learning environment and improve teacher's performance.",
            buttonText: "Fill Form",
            buttonLink: "#questionnaire-section",
        },
    ];

    const schools = [
        "School of Business and Development Studies",
        "School of Law and Humanities",
        "School of Education",
        "School of Postgraduate Studies",
        "Institute for Research & Development"
    ];

    const durations = [
        "1 to 12 Month",
        "1 to 2 Years",
        "2 to 4 Years",
        "4 Years Plus"
    ];

    const questions = [
        { id: "q1", text: "The Lecturer is prepared for each class." },
        { id: "q2", text: "The Lecturer demonstrates knowledge of the Subject." },
        { id: "q3", text: "The subject matter presented in the course has increased your knowledge of the subject." },
        { id: "q4", text: "The assignments and exams covered the materials presented in the course." },
        { id: "q5", text: "The course material is modern and updated." },
        { id: "q6", text: "I have received my study materials" },
        { id: "q7", text: "I am able to contact the University when I have a problem" },
        { id: "q8", text: "I am receiving regular contacts from the University" }
    ];

    const likertOptions = [
        "Strongly Disagree",
        "Disagree",
        "Neutral",
        "Agree",
        "Strongly Agree"
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        if (isFormValid()) {
            setSubmitted(true);

            // Reset form after 3 seconds
            setTimeout(() => {
                setSubmitted(false);
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    studentNo: "",
                    phone: "",
                    phone2: "",
                    school: "",
                    duration: "",
                    q1: "",
                    q2: "",
                    q3: "",
                    q4: "",
                    q5: "",
                    q6: "",
                    q7: "",
                    q8: ""
                });
            }, 3000);
        }
    };

    const isFormValid = () => {
        return formData.firstName &&
            formData.lastName &&
            formData.email &&
            formData.studentNo &&
            formData.phone &&
            formData.school &&
            formData.duration &&
            formData.q1 && formData.q2 && formData.q3 &&
            formData.q4 && formData.q5 && formData.q6 &&
            formData.q7 && formData.q8;
    };

    return (
        <section className="bg-gray-50 min-h-screen pt-1">
            {/* Hero Section */}
            {/* <Hero
                slides={heroSlides}
                interval={5000}
                height="350px"
                borderRadius="50px"
                hidden={true}
            /> */}

            <div className="container my-16 mx-auto px-6 py-16" id="questionnaire-section">
                <div className="max-w-4xl mx-auto">
                    {/* Introduction */}
                    <div
                        className="bg-white rounded-lg border p-6 mb-8"
                        data-aos="fade-up"
                    >
                        <p className="text-gray-700 leading-relaxed">
                            This Questionnaire Form has been designed by Keystone University of Africa / Africa Research University to get feedback from students to strengthen the quality of teaching-learning environment and to look for opportunities to improve teacher's performance in classroom engagement with students to bring excellence in teaching and learning. It is important to answer these questions as honestly as possible.
                        </p>
                    </div>

                    {/* Form */}
                    <div className="space-y-6">
                        {/* Personal Information */}
                        <div
                            className="bg-white rounded-lg border p-6"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <h3 className="text-xl font-semibold text-gray-900 mb-4">Personal Information</h3>
                            <div className="grid md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        First Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Last Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Email <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Student No <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="studentNo"
                                        value={formData.studentNo}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Phone <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Phone 2
                                    </label>
                                    <input
                                        type="tel"
                                        name="phone2"
                                        value={formData.phone2}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* School and Duration */}
                        <div
                            className="bg-white rounded-lg border p-6"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <div className="grid md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Select School <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        name="school"
                                        value={formData.school}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    >
                                        <option value="">Select a school</option>
                                        {schools.map((school, index) => (
                                            <option key={index} value={school}>
                                                {school}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        How long have you been a student here? <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        name="duration"
                                        value={formData.duration}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    >
                                        <option value="">Select duration</option>
                                        {durations.map((duration, index) => (
                                            <option key={index} value={duration}>
                                                {duration}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Questions */}
                        <div
                            className="bg-white rounded-lg border p-6"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <h3 className="text-xl font-semibold text-gray-900 mb-6">Feedback Questions</h3>
                            <div className="space-y-6">
                                {questions.map((question, index) => (
                                    <div key={question.id} className="pb-6 border-b border-gray-200 last:border-b-0 last:pb-0">
                                        <label className="block text-sm font-medium text-gray-800 mb-3">
                                            {index + 1}. {question.text} <span className="text-red-500">*</span>
                                        </label>
                                        <div className="flex flex-wrap gap-2">
                                            {likertOptions.map((option) => (
                                                <label
                                                    key={option}
                                                    className="flex-1 min-w-[120px] cursor-pointer"
                                                >
                                                    <input
                                                        type="radio"
                                                        name={question.id}
                                                        value={option}
                                                        checked={formData[question.id] === option}
                                                        onChange={handleChange}
                                                        className="sr-only"
                                                    />
                                                    <div className={`px-3 py-2 text-center text-sm rounded-lg border transition ${formData[question.id] === option
                                                        ? 'bg-green-600 text-white border-green-600'
                                                        : 'bg-white text-gray-700 border-gray-300 hover:bg-green-50'
                                                        }`}>
                                                        {option}
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div
                            className="flex justify-center"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <button
                                onClick={handleSubmit}
                                disabled={!isFormValid() || submitted}
                                className={`px-8 py-3 rounded-lg font-semibold transition ${isFormValid() && !submitted
                                    ? 'bg-green-600 text-white hover:bg-green-700 shadow-md hover:shadow-lg'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    }`}
                            >
                                {submitted ? 'Submitted Successfully!' : 'Submit Questionnaire'}
                            </button>
                        </div>

                        {submitted && (
                            <div
                                className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-center"
                                data-aos="fade-up"
                            >
                                Thank you for your feedback! Your response has been recorded.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StudentQuestionnairePage;